export default __webpack_public_path__ + "static/media/more-information.9dd6d5cc.svg";